@if (dokulinkItem.links) {
  <div>
    @if (sort(dokulinkItem.links)) {
      <div class="modal-header">
        <h5 class="modal-title">
          <strong>{{ modalTitle | translate }}</strong>
        </h5>
      </div>
    }
    <div class="modal-body">
      @if (dokulinkItem.type === "Geschaeft") {
        <p class="dokumentModalTitle">
          {{ "EBelege" | translate }}
        </p>
        @for (link of dokulinkItem.links.dokuLinks; track link) {
          <div>
            <button (click)="getDokument(link)" class="btn btn-link" type="button">
              {{ decode(link.dokumentName | translate) }}
            </button>
            <span aria-hidden="true" class="far fa-file-pdf"></span>
          </div>
        }
        <p class="dokumentModalTitle">
          {{ "EgvtBelege" | translate }}
        </p>
        @for (link of dokulinkItem.links.egvtDokuLinks; track link) {
          <div>
            <button (click)="loadEgvtDokument(link)" class="btn btn-link" type="button">
              {{ decode(link.dokumentName) }}
            </button>
            <span aria-hidden="true" class="far fa-file-pdf"></span>
          </div>
        }
      } @else {
        <p class="dokumentModalTitle">
          {{ "Dokumente" | translate }}
        </p>
        @for (link of dokulinkItem.links.dokuLinks; track link) {
          <div>
            <button (click)="getDokument(link)" class="btn btn-link" type="button">
              {{ decode(link.dokumentName | translate) }}
            </button>
            <span aria-hidden="true" class="far fa-file-pdf"></span>
          </div>
        }
      }
    </div>
    <div class="modal-footer">
      <button (click)="activeModal.close('Close click')" class="btn btn-outline-primary" type="button">
        {{ "dokulinkModal.fensterSchliessen" | translate }}
      </button>
    </div>
  </div>
}
